import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../components/modals/deleteModal";
import EnableDisableModal from "../../components/modals/enableDisableModal";
import EnabledDisabledPopUp from "../../components/popups/EnabledDisabledPopUp";
import EnabledPopUp from "../../components/popups/EnabledDisabledPopUp";
import { cfaEnableDisable } from "../../redux/actions/cfaAction";
import ErrorPopup from "../../components/popups/ErrorPopup";
import TableCFASendMailModal from "../../components/modals/cfaSendMail";

const CFATableData = ({ data, index, fetchCfaList, currentPage }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [onEnableShow, setOnEnableShow] = useState(false);
  const [enabledDisable, setEnabledDisable] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [userData, setUserData] = useState(null);
  const user_type = localStorage.getItem("userType");
  const [sendMailShow, setSendMailShow] = useState(false);

  useEffect(() => {
    if (user_type === "super_user") {
      const permissionData = JSON.parse(localStorage.getItem("permissions"));
      const permissionValue = permissionData?.find(
        (item) => item?.module_name === "CFA" && item
      );

      setUserData(permissionValue);
    }
  }, []);

  const enableDisableFunc = (id) => {
    dispatch(
      cfaEnableDisable(id, onEnableDisableSuccess, onEnableDisableError)
    );
  };

  const onEnableDisableSuccess = (data) => {
    setOnEnableShow(false);
    setEnabledDisable(true);

    const timeOutFnc = () => {
      setEnabledDisable(false);
      fetchCfaList();
    };

    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onEnableDisableError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  return (
    <tr className="table-rows1">
      <td className="table-each-row-data">
        {(currentPage - 1) * 10 + (index + 1)}
      </td>
      <td className="table-each-row-data">{data?.cfa_id}</td>
      <td className="table-each-row-data text-capitalize">{data?.cfa_name}</td>
      <td className="table-each-row-data text-capitalize">
        {data?.cfa_depot_manager}
      </td>
      <td className="table-each-row-data">+91 {data?.mobile}</td>
      <td className="table-each-row-data">{data?.email}</td>
      {data?.mail_sent == true ? (
        <td className="table-each-row-data text_green">
          <span className="fw_700 px-2">SENT</span>
        </td>
      ) : (
        <td className="table-each-row-data text_red">
          <button
            onClick={() => setSendMailShow(true)}
            className="send-mail-btn"
          >
            Send Mail
          </button>
        </td>
      )}
      {data?.status ? (
        <td className="table-each-row-data color-green">Active</td>
      ) : (
        <td className="table-each-row-data color-danger">
          <span className="fw_600">Inactive</span>
        </td>
      )}
      <td className="table-each-row-data">
        <div className="all-button">
          <button
            className="button-view"
            type="button"
            onClick={() => navigate(`/cfa/view/${data.id}`)}
          >
            View
          </button>
          {(user_type == "super_user" && userData?.write) ||
          user_type == "vendor" ? (
            <>
              <span className="vr vr_line mt-1"></span>
              <button
                className="button-edit1"
                type="button"
                onClick={() => navigate(`/cfa/edit/${data.id}`)}
              >
                Edit
              </button>
              <span className="vr vr_line mt-1"></span>
              <button
                className={data.status ? `button-disable` : `button-enable`}
                type="button"
                color={"green"}
                onClick={() => setOnEnableShow(true)}
              >
                {data.status ? "disable" : "enable"}
              </button>
            </>
          ) : (
            ""
          )}
        </div>
        <EnableDisableModal
          enableDisableFunc={enableDisableFunc}
          title={`CFA - ${data?.cfa_id} ?`}
          handleClose={() => setOnEnableShow(false)}
          id={data.id}
          status={data.status}
          show={onEnableShow}
        />
      </td>
      <EnabledDisabledPopUp
        title={`CFA - ${data?.cfa_id}`}
        show={enabledDisable}
        status={data.status}
      />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
      <TableCFASendMailModal
        data={data}
        show={sendMailShow}
        distributorListFunc={fetchCfaList}
        handleClose={() => setSendMailShow(false)}
      />
    </tr>
  );
};

export default CFATableData;
